import React from 'react';

var PlayForRealButton = function (_a) {
    var text = _a.text, onClick = _a.onClick;
    return (React.createElement("button", { className: 'play-real-btn', onClick: onClick, title: text },
        React.createElement("span", { className: 'play-real-btn-txt' }, text)));
};

export { PlayForRealButton };
